import { Controller } from '@hotwired/stimulus'

// Generic controller to toggle between three icon states: expand, collapse, loading
// Usage:
// <span data-controller="chevron-loading" data-chevron-loading-visible-icon-value="expand">
//   <span data-chevron-loading-target="expandIcon">...</span>
//   <span data-chevron-loading-target="collapseIcon">...</span>
//   <span data-chevron-loading-target="loadingSpinner">...</span>
// </span>
//
// When you modify the visibleIcon value (in element.dataset) then the icons will change
export default class extends Controller {
    static targets = ['expandIcon', 'collapseIcon', 'loadingSpinner']
    static values = { visibleIcon: String }

    connect() {
        this.#applyState(this.visibleIconValue || 'expand')
    }

    visibleIconValueChanged(value) {
        this.#applyState(value)
    }

    #applyState(state) {
        const targets = {
            expand: this.hasExpandIconTarget ? this.expandIconTarget : null,
            collapse: this.hasCollapseIconTarget ? this.collapseIconTarget : null,
            loading: this.hasLoadingSpinnerTarget ? this.loadingSpinnerTarget : null,
        }

        Object.entries(targets).forEach(([name, el]) => {
            el?.classList.toggle('d-none', name !== state)
        })
    }
}
